// Примеры для кнопки «Заполнить примером»: девять известных книг, писателей и поэтов.
// Названия и подписи ставятся сразу, картинки подгружаются в фоне теми же поисками,
// что и обычный выбор (в наших файлах картинок нет).

export const EXAMPLES = {
  books: [
    ['Мастер и Маргарита', 'Михаил Булгаков'],
    ['Преступление и наказание', 'Фёдор Достоевский'],
    ['Война и мир', 'Лев Толстой'],
    ['Евгений Онегин', 'Александр Пушкин'],
    ['Анна Каренина', 'Лев Толстой'],
    ['Тихий Дон', 'Михаил Шолохов'],
    ['Собачье сердце', 'Михаил Булгаков'],
    ['Герой нашего времени', 'Михаил Лермонтов'],
    ['Мёртвые души', 'Николай Гоголь'],
  ].map(([title, sub]) => ({ title, sub, q: `${title} ${sub.split(' ').pop()}` })),
  writers: [
    'Александр Пушкин', 'Фёдор Достоевский', 'Лев Толстой', 'Антон Чехов', 'Михаил Булгаков',
    'Анна Ахматова', 'Николай Гоголь', 'Иосиф Бродский', 'Михаил Лермонтов',
  ].map((title) => ({ title, sub: '', q: title })),
  poets: [
    ['Александр Пушкин', 'Я помню чудное мгновенье'],
    ['Михаил Лермонтов', 'Парус'],
    ['Анна Ахматова', 'Мне голос был'],
    ['Александр Блок', 'Ночь, улица, фонарь, аптека'],
    ['Сергей Есенин', 'Не жалею, не зову, не плачу'],
    ['Владимир Маяковский', 'Послушайте!'],
    ['Марина Цветаева', 'Мне нравится, что вы больны не мной'],
    ['Иосиф Бродский', 'Я входил вместо дикого зверя в клетку'],
    ['Борис Пастернак', 'Февраль. Достать чернил и плакать'],
  ].map(([title, sub]) => ({ title, sub, q: title })),
};
